'use client';

import { createContext } from 'app/libs/createContext';
import { type UseSectionType } from './useSection';

export const [SectionProvider, useSectionContext, SectionContext] =
    createContext<UseSectionType>({
        name: 'SectionContext',
    });
